import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  button: {
    borderRadius: 4,
    height: 50,
    width: '100%',
    fontSize: 20,
    backgroundColor: theme.palette.colors.lightTeal,
    color: theme.palette.colors.teal,
    marginBottom: theme.spacing(2),
    '&:hover': {
      color: theme.palette.colors.white,
      backgroundColor: theme.palette.colors.teal,
    },
    [theme.breakpoints.up('mobile')]: {
      width: '40%',
      marginRight: theme.spacing(2),
    },
  },
  selected: {
    backgroundColor: theme.palette.colors.teal,
    color: theme.palette.colors.white,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/CashOutSelectQuestion/useStyles.js